import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ModifyImageMutationVariables = Types.Exact<{
  input: Types.ModifyImageInput;
}>;


export type ModifyImageMutation = { __typename?: 'Mutation', modifyImage: { __typename?: 'ImageGenerationMutationResult', success: boolean, imageUrl?: string | null, error?: { __typename?: 'Error', code: string } | null } };


export const ModifyImageDocument = gql`
    mutation ModifyImage($input: ModifyImageInput!) {
  modifyImage(input: $input) {
    success
    imageUrl
    error {
      code
    }
  }
}
    `;
export type ModifyImageMutationFn = Apollo.MutationFunction<ModifyImageMutation, ModifyImageMutationVariables>;

/**
 * __useModifyImageMutation__
 *
 * To run a mutation, you first call `useModifyImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyImageMutation, { data, loading, error }] = useModifyImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyImageMutation(baseOptions?: Apollo.MutationHookOptions<ModifyImageMutation, ModifyImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyImageMutation, ModifyImageMutationVariables>(ModifyImageDocument, options);
      }
export type ModifyImageMutationHookResult = ReturnType<typeof useModifyImageMutation>;
export type ModifyImageMutationResult = Apollo.MutationResult<ModifyImageMutation>;
export type ModifyImageMutationOptions = Apollo.BaseMutationOptions<ModifyImageMutation, ModifyImageMutationVariables>;